import MyanmarIcon from '../images/countryOutlines/myanmar.svg';
import UkraineIcon from '../images/countryOutlines/ukraine.svg';
import SudanIcon from '../images/countryOutlines/sudan.svg';
import GazaIcon from '../images/countryOutlines/gaza.svg';
import IranIcon from '../images/countryOutlines/iran.svg';
import DRCIcon from '../images/countryOutlines/DRC.svg';

export type TMapSettings = {
    fromDate?: string;
    toDate?: string;
    category?: string;
    isoCountryCode?: string;
    mapLngLat?: [number, number]; // map.flyTo() takes lngLat
    mapZoom?: number;
};

export const areasOfConcern = [
    {
        id: 'ukraine',
        title: 'Ukraine',
        icon: UkraineIcon,
        subHeading: 'Maternal Health',
        mapSettings: {
            fromDate: '01-01-2022',
            category: 'MaternalCare',
            isoCountryCode: 'UKR',
        } as TMapSettings,
    },
    {
        id: 'drc',
        title: 'DRC',
        icon: DRCIcon,
        subHeading: 'Ebola',
        mapSettings: {
            fromDate: '21-05-2026',
            category: 'Ebola',
            isoCountryCode: 'COD',
        } as TMapSettings,
    },
    {
        id: 'myanmar',
        title: 'Myanmar',
        icon: MyanmarIcon,
        subHeading: 'Drone Impact',
        mapSettings: {
            fromDate: '01-01-2021',
            toDate: '25-03-2024',
            category: 'DroneImpact',
            isoCountryCode: 'MMR',
        } as TMapSettings,
    },
    {
        id: 'sudan',
        title: 'Sudan',
        icon: SudanIcon,
        subHeading: 'Conflict',
        mapSettings: {
            fromDate: '15-04-2023',
            category: 'Conflict',
            isoCountryCode: 'SDN',
            mapLngLat: [30.2, 15.56],
            mapZoom: 4.05,
        } as TMapSettings,
    },
    {
        id: 'iran',
        title: 'Iran',
        icon: IranIcon,
        subHeading: 'Political',
        mapSettings: {
            fromDate: '01-09-2022',
            category: 'Political',
            isoCountryCode: 'IRN',
            mapLngLat: [53.67, 32.71],
            mapZoom: 3.69,
        } as TMapSettings,
    },
    {
        id: 'gaza',
        title: 'Gaza',
        icon: GazaIcon,
        subHeading: 'Conflict',
        mapSettings: {
            fromDate: '07-10-2023',
            category: 'Conflict',
            isoCountryCode: 'PSE',
            mapLngLat: [34.35, 31.37],
            mapZoom: 9.7,
        } as TMapSettings,
    },
];
